import {
  SET_REPORT_DEFINITIONS,
  SET_REPORT_DEFINITIONS_ERROR,
  SET_REPORT_DEFINITION,
  DELETE_REPORT_DEFINITION,
} from '../constants';

const initialDefsState = {
  fetched: false,
  error: false,
  items: [],
};

const addOrReplace = (allItems, newItem) => {
  if (allItems.some(item => item.id === newItem.id)) {
    return allItems.map(item => (item.id === newItem.id ? newItem : item));
  }
  return allItems.concat(newItem);
};

const reportDefinitions = (state = initialDefsState, action) => {
  switch (action.type) {
    case SET_REPORT_DEFINITIONS:
      return {
        fetched: true,
        error: false,
        items: action.payload,
      };
    case SET_REPORT_DEFINITIONS_ERROR:
      return {
        fetched: false,
        error: true,
        items: [],
      };
    case SET_REPORT_DEFINITION:
      return {
        ...state,
        items: addOrReplace(state.items, action.payload),
      };
    case DELETE_REPORT_DEFINITION: {
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
    }
    default:
      return state;
  }
};

export default reportDefinitions;
